export default __webpack_public_path__ + "static/media/cart.bf361db9.svg";